
import { Component, Mixins } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OrderModule } from "@/store/modules/index";
import { NOTE_VISIBLE } from "@/consts";
import mixin from "./mixin";
import notifications from "../../../lib/notifications";
import * as modals from "@/lib/modals";

@Component({
  name: modals.notesModal
})
export default class NotesModal extends Mixins(mixin) {
  orderModule: OrderModule = getModule(OrderModule);
  NOTE_VISIBLE: Object = NOTE_VISIBLE;
  selectedNote: Object = null;
  notes: Array<any> = [];
  orderNumber: number = null;
  order: any = null;
  loading: boolean = false;

  get title() {
    return `Note Maintenance - ${this.orderNumber}`;
  }

  get hasNotes() {
    return this.notes.length > 0;
  }

  get displayShipWithOrderCheckbox(): boolean {
    return this.orderModule.currentOrder
      ? this.orderModule.currentOrderShipsWithOrders.length != 0
      : false;
  }

  get deliveryForId() {
    if(!this.order)
      return 0;
      
    return this.order.deliveryForId ?? 0;
  }

  async load() {
    this.show();
    this.order = this.selectedItems && this.selectedItems.length > 0 ? this.selectedItems[0] : null;
    this.orderNumber = this.order ? this.order.number : 0;
    this.loading = true;
    try {
      const response: any = await this.orderModule.getOrderNotesForOrder(this.order);
      this.notes = response.data;
    } catch (ex) {
      notifications.error("Order Notes", "Failed to load order notes", ex);
    }
    this.loading = false;
  }

  getNoteVisibility(note) {
    if (note.customerViewable & note.facilityViewable) return "ALL";
    if (note.facilityViewable) return "Network Member";
    if (note.customerViewable) return "Customer";
    return "CDS Only";
  }

  add() {
    this.orderModule.showAddNoteModal({
      orderNumber: this.order.number,
      displayShipWithOrderCheckbox: this.displayShipWithOrderCheckbox
    });
  }

  edit(note) {
    this.orderModule.editAddNoteModal(note);
  }

  async removeNote(noteId, isLegacy = false) {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      "Are you sure you want to delete this note? This action cannot be undone."
    );
    if (!confirmed) return;
    const response = await this.orderModule.deleteOrderNote({
      orderId: this.orderNumber,
      id: noteId,
      isLegacy: isLegacy
    });
    if (response) {
      let relatedNoteIndex = this.notes.map(x => x.id).indexOf(noteId);
      if (relatedNoteIndex > -1) this.notes.splice(relatedNoteIndex, 1);
    }
  }

  reset() {
    this.notes = [];
    this.order = null;
    this.loading = false;
  }
}
